import { request } from "../../utils/config"

// YAGONA CHAT (egasi 2026-09-02): MoneyComments/OrderComments o'rniga bitta API — Chat
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem("accessToken")}` })

/** Suhbatlar ro'yxati (pin, o'qilmagan, oxirgi xabar, ko'prik) */
export const GET_CONVERSATIONS = async (params?: { searchText?: string }) => {
  const response = await request({ url: `Chat/Conversations`, params, headers: auth() })
  return response.data
}

/** Xabarlar: counterpartyID (-1 = ko'prik), kind (text|event), eventType (order,money,sale,return,delivery), isDelete */
export const GET_CHAT_MESSAGES = async (params: any) => {
  const response = await request({ url: `Chat`, params, headers: auth() })
  return response.data
}

export const GET_CHAT_MESSAGE = async (id: number) => {
  const response = await request({ url: `Chat/${id}`, headers: auth() })
  return response.data
}

// Sarlavha uchun kontragent kartasi (counterparties sahifasidagi bilan bir xil)
export { GET_COUNTERPARTY } from "../counterparties/queries"

// Do'konga chiqarish (2026-09-23): chat/AI shikoyatlari navbati (Apple 1.2, Google UGC). Faqat super-admin
// yoki tenant admini ko'radi — server o'z tenanti bilan cheklaydi, qolganlarga 403.
export type ContentReportsParams = { status: 0 | 1 | 2; PageNumber?: number; PageSize?: number }

export const GET_CONTENT_REPORTS = async (params: ContentReportsParams, silent = false) => {
  const response = await request({ url: `ContentReports`, params, headers: auth(), silent })
  return response.data
}

/** «Жалобы» tugmasini ko'rsatish kerakmi: huquq ro'yxati alohida yo'q — server javobi o'zi hakam.
 *  403 (huquq yo'q) va 404 (backend hali chiqmagan) — tugma jim yashiriladi, toast chiqmaydi. */
export const GET_CONTENT_REPORTS_ACCESS = async (): Promise<{ allowed: boolean; newCount: number }> => {
  try {
    const data = await GET_CONTENT_REPORTS({ status: 0, PageSize: 1 }, true)
    return { allowed: true, newCount: Number(data?.newCount ?? data?.totalRecords ?? 0) || 0 }
  } catch (e: any) {
    const st = e?.response?.status
    if (st === 403 || st === 404) return { allowed: false, newCount: 0 }
    throw e
  }
}
